import React from 'react';
import { ErrorMessage, Field } from 'formik';
import PropTypes from 'prop-types';
import BasicLabel from '../../../../../../components/BasicLabel';
import TextEditor from '../../../../../../components/TextEditor';

const SendMessageFormMessageField = props => {
  const {
    name,
    labelText = 'Message',
    required = true,
    enableHyperlinks = true,
    labelStyles = { fontWeight: 'bold', fontSize: '0.9286rem' },
  } = props;

  return (
    <Field name={name}>
      {({
        field: { name, value },
        form: { touched, errors, setFieldValue, setFieldTouched },
      }) => (
        <>
          <BasicLabel
            name={name}
            required={required}
            text={labelText}
            styles={labelStyles}
          />

          <TextEditor
            name={name}
            enableHyperlinks={enableHyperlinks}
            editorState={value}
            controlFunc={setFieldValue}
            touchFunc={setFieldTouched}
            isValid={(!errors[name] && !!touched[name]) || !touched[name]}
          />

          <ErrorMessage
            name={name}
            render={message => <div className="form__error">{message}</div>}
          />
        </>
      )}
    </Field>
  );
};

SendMessageFormMessageField.propTypes = {
  name: PropTypes.string.isRequired,
  labelText: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  enableHyperlinks: PropTypes.bool,
  labelStyles: PropTypes.object,
};

export default SendMessageFormMessageField;
